import AddressWithRegistComponent from '@/components/AddressWithRegistComponent.vue';
import AreaComponent from '@/components/AreaWithRegistComponent.vue';
import BrandComboBoxComponent from '@/components/BrandComboBoxWithRegistComponent.vue';
import ButtonComponent from '@/components/ButtonWithRegistComponent.vue';
import CheckBoxComponent from '@/components/CheckBoxWithRegistComponent.vue';
import ColInsuranceComponent from '@/components/ColInsuranceWithRegistComponent.vue';
import ComInsuranceComponent from '@/components/ComInsuranceWithRegistComponent.vue';
import ComboBoxComponent from '@/components/ComboBoxWithRegistComponent.vue';
import ContractTermComponent from '@/components/ContractTermWithRegistComponent.vue';
import DatePickerDualComponent from '@/components/DatePickerDualComponent.vue';
import DatePickerComponent from '@/components/DatePickerWithRegistComponent.vue';
import DateYearComponent from '@/components/DatePickerYearWithRegistComponent.vue';
import DeliveryComponent from '@/components/DeliveryWithRegistComponent.vue';
import DriverComponent from '@/components/DriverWithRegistComponent.vue';
import EditorComponent from '@/components/EditorComponent.vue';
import EmailComponent from '@/components/EmailWithRegistComponent.vue';
import GarageComponent from '@/components/GarageWithRegistComponent.vue';
import GridRegitComponent from '@/components/GridRegitComponent.vue';
import GridRegitComponent2 from '@/components/GridRegitComponent2.vue';
import ImageComponent from '@/components/ImageWithRegistComponent.vue';
import InjuryComponent from '@/components/InjuryWithRegistComponent.vue';
import InputBoxTimeComponent from '@/components/InputBoxTimeComponent.vue';
import InputBoxComponent from '@/components/InputBoxWithRegistComponent.vue';
import InsuranceListComponent from '@/components/InsuranceListComponent.vue';
import InsuranceRentalListComponent from '@/components/InsuranceRentalListWithRegistComponent.vue';
import InsurancComponent from '@/components/InsusranceWithRegistComponent.vue';
import LabelComponent from '@/components/LabelWithRegistComponent.vue';
import LicenceComponent from '@/components/LicenceRegistComponent.vue';
import LoginIdComponent from '@/components/LoginIdWithRegistComponent.vue';
import ModelComponent from '@/components/ModelWithRegistComponent.vue';
import MultiCheckBoxComponent from '@/components/MultiCheckBoxWithRegistComponent.vue';
import MultiComboBoxComponent from '@/components/MultiComboBoxWithRegistComponent.vue';
import MultiUploadBoxWithRegistComponent from '@/components/MultiUploadBoxWithRegistComponent.vue';
import NoteListComponent from '@/components/NoteListComponent.vue';
import RadioButtonComponent from '@/components/RadioButtonWithRegistComponent.vue';
import RatingRegistComponent from '@/components/RatingRegistComponent.vue';
import AccidentInfoComponent from '@/components/RegistFormComponents/AccidentInfoComponent.vue';
import AdditionalInfoComponent from '@/components/RegistFormComponents/AdditionalInfoComponent.vue';
import CollisionInfoComponent from '@/components/RegistFormComponents/CollisionInfoComponent.vue';
import ContractNoteInfoComponent from '@/components/RegistFormComponents/ContractNoteInfoComponent.vue';
import ContractVehicleInfoComponent from '@/components/RegistFormComponents/ContractVehicleInfoComponent.vue';
import CustomerInfoComponent from '@/components/RegistFormComponents/CustomerInfoComponent.vue';
import InsuranceInfoComponent from '@/components/RegistFormComponents/InsuranceInfoComponent.vue';
import InsuranceReservationInfoComponent from '@/components/RegistFormComponents/InsuranceReservationInfoComponent.vue';
import PaymentInfoComponent from '@/components/RegistFormComponents/PaymentInfoComponent.vue';
import ReservationInfoComponent from '@/components/RegistFormComponents/ReservationInfoComponent.vue';
import VehicleInfoComponent from '@/components/RegistFormComponents/VehicleInfoComponent.vue';
import RentalPreviewComponent from '@/components/RentalPreviewComponent.vue';
import SelectBoxComponent from '@/components/SelectBoxWithRegistComponent.vue';
import SignComponent from '@/components/SignWithRegistComponent.vue';
import SwitchComponent from '@/components/SwitchWithRegistComponent.vue';
import TextAreaComponent from '@/components/TextAreaWithRegistComponent.vue';
import TimeComboBoxComponent from '@/components/TimeComboBoxWithRegistComponent.vue';
import TimePickerComponent from '@/components/TimePickerComponent.vue';
import ToggleSwitchComponent from '@/components/ToggleSwitchWitthRegistComponent.vue';
import { default as ThtmlviewcontractComponent, default as ThtmlviewcontractComponentDiv } from '@/components/TtmlViewContractComponent.vue';
import TtmlViewTemplateComponent from '@/components/TtmlViewTemplateComponent.vue';
import UploadBoxWithRegistComponent from '@/components/UploadBoxWithRegistComponent.vue';
import VehicleGroupComponent from '@/components/VehicleGroupWithRegistComponent.vue';
import VehicleNoComponent from '@/components/VehicleNoWithRegistComponent.vue';
import VehicleOptionComponent from '@/components/VehicleOptionWithRegistComponent.vue';
import VehicleComponent from '@/components/VehicleWithRegistComponent.vue';
import HtmlTemplateComponent from '@/components/htmlTemplateComponent.vue';
import { AgGridVue } from 'ag-grid-vue3';

export default {
    install(app) {
        app.component('inputbox', InputBoxComponent);
        app.component('textarea', TextAreaComponent);
        app.component('customtextbox', TextAreaComponent);
        app.component('selectbox', SelectBoxComponent);
        app.component('combobox', ComboBoxComponent);
        app.component('brandcombobox', BrandComboBoxComponent);
        app.component('model', ModelComponent);
        app.component('datepicker', DatePickerComponent);
        app.component('timeonly', InputBoxTimeComponent);
        app.component('dateyear', DateYearComponent);
        app.component('datepickerDual', DatePickerDualComponent);
        app.component('timepicker', TimePickerComponent);
        app.component('checkbox', CheckBoxComponent);
        app.component('mycheckbox', CheckBoxComponent);
        app.component('multicheckbox', MultiCheckBoxComponent);
        app.component('multiuploadbox', MultiUploadBoxWithRegistComponent);
        app.component('radiobutton', RadioButtonComponent);
        app.component('area', AreaComponent);
        app.component('vehiclegroup', VehicleGroupComponent);
        app.component('vehicleoption', VehicleOptionComponent);
        app.component('image', ImageComponent);
        app.component('button', ButtonComponent);
        app.component('label', LabelComponent);
        app.component('vehicle', VehicleComponent);
        app.component('delivery', DeliveryComponent);
        app.component('driver', DriverComponent);
        app.component('injury', InjuryComponent);
        app.component('insurance', InsurancComponent);
        app.component('cominsurance', ComInsuranceComponent);
        app.component('colinsurance', ColInsuranceComponent);
        app.component('contractterm', ContractTermComponent);
        app.component('notelist', NoteListComponent);
        app.component('htmlviewtemplate', TtmlViewTemplateComponent);
        app.component('htmlviewcontract', ThtmlviewcontractComponent);
        app.component('htmlviewcontractDiv', ThtmlviewcontractComponentDiv);
        app.component('gridlist', GridRegitComponent);
        app.component('gridlist2', GridRegitComponent2);
        // app.component('email', EmailInputBoxComponent);
        app.component('uploadbox', UploadBoxWithRegistComponent);
        app.component('htmlTemplate', HtmlTemplateComponent);
        app.component('loginid', LoginIdComponent);
        app.component('vehicleno', VehicleNoComponent);
        app.component('email', EmailComponent);
        app.component('multicombobox', MultiComboBoxComponent);
        app.component('garage', GarageComponent);
        app.component('editor', EditorComponent);
        app.component('licence', LicenceComponent);
        app.component('timecombobox', TimeComboBoxComponent);
        app.component('insurancelist', InsuranceListComponent);
        app.component('rating', RatingRegistComponent);
        app.component('rentalpreview', RentalPreviewComponent);
        app.component('togglebox', ToggleSwitchComponent);
        app.component('switchbox', SwitchComponent);
        app.component('vehicleinfo', VehicleInfoComponent);
        app.component('contractvehicleinfo', ContractVehicleInfoComponent);
        app.component('customerinfo', CustomerInfoComponent);
        app.component('collisioninfo', CollisionInfoComponent);
        app.component('insuranceinfo', InsuranceInfoComponent);
        app.component('reservationinfo', ReservationInfoComponent);
        app.component('insurancereservationinfo', InsuranceReservationInfoComponent);
        app.component('contractnoteinfo', ContractNoteInfoComponent);
        app.component('addresscomponent', AddressWithRegistComponent);
        app.component('accidentinfo', AccidentInfoComponent);
        app.component('additionalinfo', AdditionalInfoComponent);
        app.component('paymentinfo', PaymentInfoComponent);
        app.component('sign', SignComponent);
        app.component('insurancerentallist', InsuranceRentalListComponent);
        app.component('AgGridVue', AgGridVue);
    }
};
